import { API_AUTHORITY_LIST , API_AUTHORITY_DELETE, API_AUTHORITY_SAVE, API_RESOURCE_NOTIN_ROLE_LIST} from '@/common/constants';
import { get, post, del, put } from '@/utils/http';

export const getResourceListByRoleId = (currentPage = 1, pageSize = 10, roleId) => {
    return get(API_AUTHORITY_LIST, { currentPage, pageSize, roleId: roleId });
};

export const delRoleResource = (roleResourceId) => {
    return del(API_AUTHORITY_DELETE.replace(':roleResourceId', roleResourceId));
};

export const saveMultRoleResource = (roleResource) => {
    return post(API_AUTHORITY_SAVE, roleResource);
};

export const getResourceListNotInRole = (currentPage = 1, pageSize = 10, roleId, label, state) => {
    return get(API_RESOURCE_NOTIN_ROLE_LIST, { currentPage, pageSize, roleId: roleId,label: label,state:state });
};
// Resource RESOURCE resource



// WEBPACK FOOTER //
// ./src/data-model/system/authority-model.js